import { render } from "./_CommentReply.vue?vue&type=template&id=111872a6"
import script from "./_CommentReply.vue?vue&type=script&lang=js"
export * from "./_CommentReply.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__